<template>
  <div class="container mt-5">
    <h1 class="text-center mb-4">Mis Documentos</h1>

    <!-- Subida de documentos -->
    <div class="mb-4">
      <input type="file" @change="handleFileUpload" />
    </div>

    <div v-if="documentos.length">
      <ul>
        <li v-for="documento in documentos" :key="documento.id" class="flex justify-between items-center">
          <a :href="documento.url" target="_blank" class="text-blue-600 underline">{{ documento.nombre }}</a>
          <button @click="eliminarDocumento(documento)" class="text-red-500 hover:text-red-700">Eliminar</button>
        </li>
      </ul>
    </div>
    
    <div v-else>
      <p>No hay documentos disponibles.</p>
    </div>
  </div>
</template>

<script>
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { db, storage } from '@/firebase'; // Asegúrate que storage esté exportado desde firebase.js

export default {
  data() {
    return {
      documentos: [],
    };
  },

  async mounted() {
    this.cargarDocumentos();
  },

  methods: {
    async cargarDocumentos() {
      const pacienteId = this.$route.params.pacienteId;
      try {
        const snap = await getDocs(collection(db, `pacientes/${pacienteId}/documentos`));
        this.documentos = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      } catch (e) {
        console.error("Error al cargar documentos:", e);
      }
    },

    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const pacienteId = this.$route.params.pacienteId;
      const storageRef = ref(storage, `documentos_pacientes/${pacienteId}/${file.name}`);

      try {
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);

        // Guarda en Firestore
        await addDoc(collection(db, `pacientes/${pacienteId}/documentos`), {
          nombre: file.name,
          url,
          timestamp: new Date(),
        });

        this.cargarDocumentos();
      } catch (e) {
        console.error("Error subiendo archivo:", e);
      }
    },

    async eliminarDocumento(documento) {
      const pacienteId = this.$route.params.pacienteId;

      const storagePath = `documentos_pacientes/${pacienteId}/${documento.nombre}`;
      const fileRef = ref(storage, storagePath);

      try {
        await deleteObject(fileRef);
        await deleteDoc(doc(db, `pacientes/${pacienteId}/documentos`, documento.id));
        this.cargarDocumentos();
      } catch (e) {
        console.error("Error al eliminar documento:", e);
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 900px;
}
</style>
